import React, { useEffect, useState } from "react";
import aries from "../../../assets/images/Horoscope/astro.png";
import Aquarius from "../../../assets/images/Horoscope/c.jpg";
import cancer from "../../../assets/images/Horoscope/cancer.jpg";
import capricorn from "../../../assets/images/Horoscope/capricornus.jpg";
import Leo from "../../../assets/images/Horoscope/leo.jpg";
import libra from "../../../assets/images/Horoscope/libra.jpg";
import pisces from "../../../assets/images/Horoscope/pisces.jpg";
import sagittarius from "../../../assets/images/Horoscope/sssagittarius.jpg";
import taurus from "../../../assets/images/Horoscope/taurussss.jpg";
import virgo from "../../../assets/images/Horoscope/virgo.jpg";
import Zodiac from "../../../assets/images/Horoscope/ic_gemini.png";
import Scorpio from "../../../assets/images/Horoscope/scorpio.jpg";
import { GetUserModel } from "../../../ApiServices/Profile/ProfileApi";
import { daily_nakshatra_prediction } from "../../../ApiServices/Horoscope/BirthDetailsApi";
import dayjs from "dayjs";
import PredictionModal from "./PredictionModal";
import Breadcrumbs from "../../Breadcrumb";
import HoroscopeBannerImg from "../../../assets/images/new/HoroscopeBanner.png";
import astroBackgroundImg from "../../../assets/images/Horoscope/horoscopeBackgroundImg.png";
import astrology from "../../../assets/images/new/astrology.png";
import panchang from "../../../assets/images/new/panchang.png";
import numerology from "../../../assets/images/new/numerology.png";
import zodiacSign from "../../../assets/images/new/zodiacSign.png";
import Astro from "../../../assets/images/new/services1 (1).jpg";
import Panchang from "../../../assets/images/new/services1 (2).jpg";
import NumerologyImage from "../../../assets/images/new/services1 (3).jpg";
import PredictionImage from "../../../assets/images/new/services1 (3).jpg";
import batuk from "../../../assets/images/new/fav-removebg-preview.png";
import { useLocation, useNavigate } from "react-router-dom";
import ErrorMassagePupUp from "../../ErrorMassagePupUp";
const Prediction = () => {
  const [dailyPredictionList, setDailyPredictionObj] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [predictionTitle, setPredictionTitle] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [customErrorMassage, setCustomErrorMassage] = useState("")
  const zodiacData = [
    {
      zodiacSign: "Aries",
      zodiacName: "Mesha",
      zodiacLogo: aries,
      color: "#a426421a",
    },
    {
      zodiacSign: "Taurus",
      zodiacName: "Vrishabha",
      zodiacLogo: taurus,
      color: "#d0e6c5",
    },
    {
      zodiacSign: "Gemini",
      zodiacName: "Mithuna",
      zodiacLogo: Zodiac,
      color: "rgb(243 240 12 / 28%)",
    },
    {
      zodiacSign: "Cancer",
      zodiacName: "Karka",
      zodiacLogo: cancer,
      color: "rgb(178 187 223 / 29%)",
    },
    {
      zodiacSign: "Leo",
      zodiacName: "Simha",
      zodiacLogo: Leo,
      color: "rgb(176 238 241 / 43%)",
    },
    {
      zodiacSign: "Virgo",
      zodiacName: "Kanya",
      zodiacLogo: virgo,
      color: "#e4c7c7b3",
    },
    {
      zodiacSign: "Libra",
      zodiacName: "Tula",
      zodiacLogo: libra,
      color: "rgb(196 221 119 / 39%)",
    },
    {
      zodiacSign: "Scorpio",
      zodiacName: "Vrishchika",
      zodiacLogo: Scorpio,
      color: "#7a568530",
    },
    {
      zodiacSign: "Sagittarius",
      zodiacName: "Dhanu",
      zodiacLogo: sagittarius,
      color: "rgb(235 137 237 / 15%)",
    },
    {
      zodiacSign: "Capricorn",
      zodiacName: "Makara",
      zodiacLogo: capricorn,
      color: "#8bba9f66",
    },
    {
      zodiacSign: "Aquarius",
      zodiacName: "Kumbha",
      zodiacLogo: Aquarius,
      color: "#a426421a",
    },
    {
      zodiacSign: "Pisces",
      zodiacName: "Meena",
      zodiacLogo: pisces,
      color: "#fefb1338",
    },
  ];

  useEffect(() => {
    GetUserModelData();
  }, []);

  const GetUserModelData = async () => {
    // setLoader(true);

    const userID = JSON.parse(localStorage.getItem("userID"));
    try {
      const response = await GetUserModel(userID);
      if (response?.ResponseCode == 0) {
        // setLoader(false);
        const ModelData = response.DATA || []; // Assuming the data is an array and we need the first item

        const dob = new Date(ModelData[0]?.DOB);

        const year = dob.getFullYear();
        const month = dob.getMonth() + 1; // Months are zero-based (0 = January)
        const day = dob.getDate();

        const [hours, minutes] = ModelData[0]?.BIRTH_TIME.split(":");
        const apiParam = {
          day: day.toString(),
          month: month.toString(),
          year: year.toString(),
          hour: hours.toString(),
          min: minutes.toString(),
          lat: 25.7464,
          lon: 25.7464,
          tzone: 5.5,
        };
        await GetDailyPredictionData(
          apiParam,
          dayjs(ModelData[0]?.DOB).format("DD/MM/YYYY")
        );
      } else {
        // setLoader(false);

        console.error(
          "Error fetching data: ",
          response?.data?.data?.statusCode
        );
      }
    } catch (error) {
      // setLoader(false);

      console.error("Error", error);
    }
  };
  const GetDailyPredictionData = async (apiParam, birthDate) => {

    try {
      const response = await daily_nakshatra_prediction(apiParam);
      if (response !== null && response !== undefined) {
        // setLoader(false);
        setDailyPredictionObj((prev) => ({
          ...prev,
          Health: response?.prediction?.health,
          Emotion: response?.prediction?.emotions,
          Profession: response?.prediction?.profession,
          Luck: response?.prediction?.luck,
          Personal_life: response?.prediction?.personal_life,
          Travel: response?.prediction?.travel,
        }));
      } else {
        // setLoader(false);

        console.error("Error fetching data: ", response);
      }
    } catch (error) {
      // setLoader(false);
      setCustomErrorMassage(error?.response?.data?.msg)
      setShowErrorModal(true)
      console.error("Error", error);
    }
  };

  const handleClickedOnSign = (value) => {
    setShowModal(true);
    setPredictionTitle(value);
  };

  const HandleCloseModal = () => {
    setShowErrorModal(false)
    navigate("/")
  }
  return (
    <>
      <div
        class="row p-2 main-sign"
        style={{ width: "87%", marginLeft: "6.25rem", marginRight: "19.25rem", marginBottom: '40px' }}
      >
        <div
          className="section-title text-center"
          style={{ marginBottom: "20px", marginTop: "50px" }}
        >
          <h6 className="sec-title__tagline bw-split-in-center flex justify-center items-center gap-2">
            <img className="tagline-img" src={batuk} alt="batuk img" />
            Decode Your Destiny
          </h6>

          <h3 className="sec-title__title bw-split-in-left ">
            Numerology and Your Life Path
          </h3>
        </div>
        {zodiacData.map((zodiac, index) => (
          <div key={index} className="col-md-3 col-sm-6 mb-4 p-2">
            <div
              className="card shadow-md border-0 p-4 text-center"
              style={{ cursor: "pointer", backgroundColor: zodiac?.color }}
              onClick={() => handleClickedOnSign(zodiac.zodiacSign)}
            >
              <div className="zodiac-icon">
                <img
                  width={50}
                  height={50}
                  src={zodiac.zodiacLogo}
                  alt={zodiac.zodiacName}
                  className="rounded-circle border"
                />
              </div>
              <h5
                className="fw-bold mb-2 zodiac-name "
                style={{ textAlign: "center" }}
              >
                {zodiac.zodiacSign}
              </h5>
              <p className="zodiac-sign" style={{ textAlign: "center" }}>
                {zodiac.zodiacName}
              </p>
            </div>
          </div>
        ))}
      </div>
      <ErrorMassagePupUp show={showErrorModal} onHide={() => HandleCloseModal()} Massage={customErrorMassage} />
      <PredictionModal
        show={showModal}
        onHide={() => setShowModal(false)}
        dailyPredictionList={dailyPredictionList}
        predictionTitle={predictionTitle}
      />
    </>
  );
};

export default Prediction;
